import { routes } from '../constants';
import { initialValueCallWoman } from 'helpers';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrderStore } from 'store';
import { EOrderStep, TMaleDetail, TRecommendFemale } from 'types';

export type GotoCallNavigationState = {
  nominatedFemale?: TRecommendFemale;
  invitedMales?: TMaleDetail[];
  sourceChannelId?: string;
  /** When set, order is treated as male-origin setting (settingFemaleId). */
  fixedFemaleId?: number;
};

function useOrder() {
  const {
    setOrderFormState,
    setOrderStep,
    setFixedFemaleId,
    setSourceChannelId,
  } = useOrderStore();
  const navigate = useNavigate();

  const gotoCall = useCallback(
    async (state?: GotoCallNavigationState) => {
      setOrderFormState(initialValueCallWoman);
      setOrderStep(EOrderStep.CALL_WOMAN);
      
      // Persist setting-order meta in the store: Call/clearState clears location.state.
      setFixedFemaleId(state?.fixedFemaleId ?? null);
      setSourceChannelId(
        state?.fixedFemaleId ? state.sourceChannelId ?? null : null,
      );
      navigate(routes.CALL, { state: state ?? {} });
    },
    [
      navigate,
      setOrderFormState,
      setOrderStep,
      setFixedFemaleId,
      setSourceChannelId,
    ],
  );

  return { gotoCall };
}

export default useOrder;
